import type { TripItineraryData, TripStopWithDays } from 'tripPlanner/api/types'

function getStopTypeOrder(stopType: TripStopWithDays['stopType']): number {
  return stopType === 'ORIGIN' ? 0 : 1
}

function compareTripStopsByItineraryOrder(left: TripStopWithDays, right: TripStopWithDays): number {
  const sequenceOrder = left.stopSeq - right.stopSeq
  if (sequenceOrder !== 0) return sequenceOrder

  return getStopTypeOrder(left.stopType) - getStopTypeOrder(right.stopType)
}

export function sortTripStopsByItineraryOrder(stops: Array<TripStopWithDays>): Array<TripStopWithDays> {
  return [...stops].sort(compareTripStopsByItineraryOrder)
}

export function orderTripItineraryStops(itineraryData: TripItineraryData | undefined): TripItineraryData | undefined {
  if (!itineraryData) return itineraryData

  return {
    ...itineraryData,
    stops: sortTripStopsByItineraryOrder(itineraryData.stops),
  }
}
